export const FETCH_INTERACTIONS_BY_CASE_ID = 'FETCH_INTERACTIONS_BY_CASE_ID';
export const FETCH_INTERACTIONS_BY_CASE_ID_START = `${FETCH_INTERACTIONS_BY_CASE_ID}_START`;
export const FETCH_INTERACTIONS_BY_CASE_ID_SUCCESS = `${FETCH_INTERACTIONS_BY_CASE_ID}_SUCCESS`;
export const FETCH_INTERACTIONS_BY_CASE_ID_ERROR = `${FETCH_INTERACTIONS_BY_CASE_ID}_ERROR`;
export const FETCH_CASE_UPDATES = 'FETCH_CASE_UPDATES';
export const FETCH_CASE_UPDATES_START = `${FETCH_CASE_UPDATES}_START`;
export const FETCH_CASE_UPDATES_SUCCESS = `${FETCH_CASE_UPDATES}_SUCCESS`;
export const FETCH_CASE_UPDATES_ERROR = `${FETCH_CASE_UPDATES}_ERROR`;
export const FETCH_CASE_NOTIFICATIONS = 'FETCH_CASE_NOTIFICATIONS';
export const FETCH_CASE_NOTIFICATIONS_START = `${FETCH_CASE_NOTIFICATIONS}_START`;
export const FETCH_CASE_NOTIFICATIONS_SUCCESS = `${FETCH_CASE_NOTIFICATIONS}_SUCCESS`;
export const FETCH_CASE_NOTIFICATIONS_ERROR = `${FETCH_CASE_NOTIFICATIONS}_ERROR`;
export const FETCH_CASE_SATISFACTIONS = 'FETCH_CASE_SATISFACTIONS';
export const FETCH_CASE_SATISFACTIONS_START = `${FETCH_CASE_SATISFACTIONS}_START`;
export const FETCH_CASE_SATISFACTIONS_SUCCESS = `${FETCH_CASE_SATISFACTIONS}_SUCCESS`;
export const FETCH_CASE_SATISFACTIONS_ERROR = `${FETCH_CASE_SATISFACTIONS}_ERROR`;
export const UPDATE_CONTINUED_EVENT = 'UPDATE_CONTINUED_EVENT';
export const NEW_UPDATE = 'NEW_UPDATE';
//# sourceMappingURL=actionTypes.js.map